<style scoped lang="scss" type="text/scss">
    .content-component-container {
        max-height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .line-divider {
            margin-top: 1rem;
        }

        .content-wrap {
            flex: 1;
            overflow: hidden;
            position: relative;
        }
    }
</style>

<template>
    <div class="content-component-container">
        <special-competition-selector-panel></special-competition-selector-panel>
        <line-divider class="line-divider"></line-divider>

        <div class="content-wrap">
            <player-contact></player-contact>
        </div>
    </div>
</template>

<script>
    import SpecialCompetitionSelectorPanel from './special-competition-selector-panel';
    import InfoPanel from '../../../../../components/info-panel/index';
    import PlayerContact from './player-contact';

    export default {
        name: '',
        components: {
            SpecialCompetitionSelectorPanel,
            InfoPanel,
            PlayerContact
        },
        data () {
            return {};
        }
    };
</script>
